import script from "./DropshipSearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./DropshipSearchBar.vue?vue&type=script&setup=true&lang=js"

import "./DropshipSearchBar.vue?vue&type=style&index=0&id=3212f9e6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3212f9e6"]])

export default __exports__